import type { Country, DeliveryZoneCode } from '@noths/polaris-client-localisation';
import {
  countries,
  deliveryZoneCodes,
  deliveryZoneCodeValues,
  ukDeliveryZones,
} from '@noths/polaris-client-localisation';
import { createSelector } from '@reduxjs/toolkit';
import * as R from 'ramda';

import type { ReduxApplicationState } from '../combinedReducer';

export const selectProduct = (state: ReduxApplicationState) => state.product;

export const selectProductPrice = (state: ReduxApplicationState) => state.product.price;

export const selectProductPartner = (state: ReduxApplicationState) => state.product.partner;

export const selectProductDeliveryByEvent = (state: ReduxApplicationState) =>
  state.product.deliveryByEvent;

export const selectProductDeliveryOptions = (state: ReduxApplicationState) =>
  state.product.deliveryOptions;

export const selectPersonalisationOptions = createSelector(
  [selectProduct],
  (product) => product.options,
);

export const selectZonesDeliveredTo = createSelector(
  [selectProductDeliveryOptions],
  (productDeliveryOptions): DeliveryZoneCode[] =>
    productDeliveryOptions
      ? R.uniq(productDeliveryOptions.map(({ zone }) => deliveryZoneCodes[zone.id]))
      : [],
);

export const selectHasUKDeliveryOnly = createSelector(
  [selectZonesDeliveredTo],
  (zonesDeliveredTo) => !zonesDeliveredTo.some((zoneCode) => !ukDeliveryZones.includes(zoneCode)),
);

export const selectHasSelectedCountriesDeliveryOnly = createSelector(
  [selectHasUKDeliveryOnly, selectZonesDeliveredTo],
  (hasUKDeliveryOnly, zonesDeliveredTo): boolean =>
    !(
      hasUKDeliveryOnly ||
      deliveryZoneCodeValues.every((zoneCode) =>
        zonesDeliveredTo.includes(zoneCode as DeliveryZoneCode),
      )
    ),
);

export const selectCountriesDeliveredTo = createSelector(
  [selectZonesDeliveredTo],
  (zonesDeliveredTo): Country[] =>
    countries.filter(({ deliveryZoneCode }) =>
      zonesDeliveredTo.includes(deliveryZoneCode as DeliveryZoneCode),
    ),
);
